import * as query from "@arcgis/core/rest/query.js";
import { httpGet, httpPost, httpPostDownloadFile } from "../httpService/httpService";
import {
    AddRegistrationCardRastersProps, CardsVaildationRequest, CardsValidationProps, QueryDocumentsProps, QueryPublicationsProps, RegistrationCardIds,
    RegistrationCardProperties, SaveRegistrationCardProps, StatusValidationCardProps, ValidateSelectedCardsProps,
    SaveRegistrationCardCommentsProps,
    CardStateUpdate,
    CheckEditor,
    ObjectsReturn,
    AddRegistrationCardMonitoringProps,
    Cards,
    CardsDownloadProps,
    CardDownloadMode
} from "./types/registrationCardServiceProps";
import { ConfigField, KrEndangeredAreaFormTypes, krFormTypes, KrLandslideFormTypes } from "../../contexts/krFormContext";
import { ObjectType } from "../../contexts/types/card";
import { ObjectState } from "../../containers/centralView/taskListView/types/tasklListViewProps";
import { createValidationKrForm, validationErrorsKrForm } from "../../helpers/validation/validation";
import { Dictionary, getDictionariesForValidation } from "../../helpers/dictionariesFromLayers";

export const CreateRegistrationCard = (Data: RegistrationCardProperties, apiUrl: string, apiVersion: string) => {
    return new Promise((resolve, reject) => {
        httpPost(apiUrl + apiVersion + "/create-registrationCard", Data
        ).then((data: any) => {
            resolve(data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}

export const UpdateRegistrationCardSingle = async (Ids: RegistrationCardIds[], apiUrl: string, apiVersion: string, where: string, arcGisUrl: string, isLandslide: boolean) => {
    if (isLandslide) where = where + " AND (RODZAJ_OBIEKTU='KRO')";
    else where = where + " AND (RODZAJ_OBIEKTU='KRTZ')";
    await query.executeQueryJSON(arcGisUrl, { where: where, outFields: ["WZOR", "GLOBALID", "RODZAJ_OBIEKTU", "NUMER_IDENTYFIKACYJNY"], returnGeometry: false })
        .then((res) => {
            // archId = res.features[0].attributes["ARCH_ID"];
            // globalId = res.features[0].attributes["GLOBALID"];
            var registrationCard: RegistrationCardIds = {
                Type: res.features[0].attributes["RODZAJ_OBIEKTU"] === ObjectType.KRO ? "osuwisko" : "tz",
                globalId: res.features[0].attributes["GLOBALID"],
                cardPattern: res.features[0].attributes["WZOR"],
                Id: res.features[0].attributes["NUMER_IDENTYFIKACYJNY"].toString()
            }
            Ids.push(registrationCard);
            // formData.append('IdNumber', props.idNumber);
            // formData.append('ArchId', archId);
            // formData.append('GlobalId', globalId);
            // formData.append('IsLandslide', JSON.stringify(props.isLandslide));
        })
        .catch((err) => {
            console.log("err Query: ", err)
        })
    return Ids;
    //return UpdateRegistrationCard(Ids, apiUrl, apiVersion);
}

export const UpdateRegistrationCard = (Ids: RegistrationCardIds[], apiUrl: string, apiVersion: string) => {
    return new Promise((resolve, reject) => {
        httpPost(apiUrl + apiVersion + "/update-registrationCard", Ids
        ).then((data: any) => {
            resolve(data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}

export const populateRegistrationCardForm = async (objectType: string, waitingRoomGlobalId: string, apiUrl: string, isEditMode: boolean, changeStatus: boolean, newStatus?: ObjectState) => {
    const cardType = getCardType(objectType);
    const populationMode = isEditMode ? "editMode" : "verficationMode";

    if (changeStatus) {
        return new Promise((resolve, reject) => {
            httpPost(apiUrl + `/populate-${cardType}Card-form-change-status-${populationMode}`, { gids: [waitingRoomGlobalId], state: newStatus }).then((data: any) => {
                resolve(data as krFormTypes);
            }).catch((error: any) => {
                reject(error);
            });
        });
    }
    else {
        return new Promise((resolve, reject) => {
            httpGet(apiUrl + `/${waitingRoomGlobalId}/populate-${cardType}Card-form-${populationMode}`).then((data: any) => {
                resolve(data as krFormTypes);
            }).catch((error: any) => {
                reject(error);
            });
        });
    }
}

export const populateCollectiveCardForm = async (objectType: string, gids: string[], apiUrl: string) => {
    const cardType = getCardType(objectType);
    return new Promise((resolve, reject) => {
        httpPost(apiUrl + `/populate-collective-${cardType}`, gids).then((data: any) => {
            resolve(data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}

export const checkAssignStatus = async (gids: string[], apiUrl: string) => {
    return new Promise((resolve, reject) => {
        httpPost(apiUrl + `/check-assign-status`, gids).then((data: any) => {
            resolve(data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}

export const checkCollectiveProgress = async (gid: string, apiUrl: string) => {
    return new Promise((resolve, reject) => {
        httpGet(apiUrl + `/collective-progress?guid=${gid}`).then((data: any) => {
            resolve(data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}

export const changeStatusRegistrationCardForm = async (status: string, gids: string[], apiUrl: string, isEditor: boolean) => {
    const role = isEditor ? "editor" : "verifier";
    return new Promise((resolve, reject) => {
        httpPost(apiUrl + `/${role}-update-card-state`, { gids: gids, state: status }).then((res: any) => {
            resolve(res.data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}

export const changeStatusRegistrationCardFormForCollectiveEdit = async (status: string, gids: string[], apiUrl: string) => {
    return new Promise((resolve, reject) => {
        httpPost(apiUrl + "/collective-edit-update-card-state", { gids: gids, state: status }).then((res: any) => {
            resolve(res.data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}

export const changeStatusRegistrationCardFormForDownload = async (cards: CardStateUpdate[], apiUrl: string) => {
    return new Promise((resolve, reject) => {
        httpPost(apiUrl + `/download-update-card-state`, { cardStates: cards, userToken: "" }).then((res: any) => {
            resolve(res.data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}

export const returnCards = async (cards: ObjectsReturn, apiUrl: string) => {
    return new Promise((resolve, reject) => {
        httpPost(apiUrl + `/return-card`, cards).then((res: any) => {
            resolve(res.data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}

export const createCollectiveProgress = async (apiUrl: string) => {
    return new Promise((resolve, reject) => {
        httpPost(apiUrl + `/create-collective-progress`).then((res: any) => {
            resolve(res.data);
        }).catch((error: any) => {
            reject(error);
        });
    });
}

export const queryDocuments = async (props: QueryDocumentsProps) => {

    const formData = new FormData();
    formData.append('LandslideDocuments', JSON.stringify(props.landslideDocuments));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/query-documents`, formData)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const queryPublications = async (props: QueryPublicationsProps) => {

    const formData = new FormData();
    formData.append('LandslidePublications', JSON.stringify(props.landslidePublications));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/query-publications`, formData)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const addRegistrationCardRasters = async (props: AddRegistrationCardRastersProps) => {

    const formData = new FormData();
    formData.append('RastersAttributes', JSON.stringify(props.rastersAttributes));
    formData.append('ObjectIdNumber', props.objectIdNumber.toString());
    formData.append('IsLandslide', props.isLandslide.toString());
    formData.append('WaitingRoomGlobalId', props.waitingRoomGlobalId ? props.waitingRoomGlobalId : "");
    formData.append('FilePath', props.filePath);

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/add-registration-card-rasters`, formData)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const addRegistrationCardMonitoring = async (props: AddRegistrationCardMonitoringProps) => {

    const formData = new FormData();
    formData.append('Monitoring', JSON.stringify(props.monitoring));
    formData.append('MonitoringAttachments', JSON.stringify(props.monitoringAttachments));
    formData.append('ObjectIdNumber', props.objectIdNumber.toString());
    formData.append('WaitingRoomGlobalId', props.waitingRoomGlobalId ? props.waitingRoomGlobalId : "");
    formData.append('FilePath', props.filePath);

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/add-registration-card-monitoring`, formData)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const updateRegistrationCardMonitoring = async (props: AddRegistrationCardMonitoringProps) => {

    const formData = new FormData();
    formData.append('Monitoring', JSON.stringify(props.monitoring));
    formData.append('MonitoringAttachments', JSON.stringify(props.monitoringAttachments));
    formData.append('ObjectIdNumber', props.objectIdNumber.toString());
    formData.append('WaitingRoomGlobalId', props.waitingRoomGlobalId ? props.waitingRoomGlobalId : "");
    formData.append('FilePath', props.filePath);

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/update-registration-card-monitoring`, formData)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const saveRegistrationCard = async (props: SaveRegistrationCardProps) => {
    const formData = new FormData();
    
    var clearedForm = structuredClone(props.form);

    switch (props.objectType) {
        case ObjectType.KRO:
            (clearedForm as KrLandslideFormTypes).landslideRasters = (clearedForm as KrLandslideFormTypes).landslideRasters?.map(item => {
                if (item.details !== undefined && item.details.blob !== null) item.details!.blob = null;
                return item;
            })
            break;
        case ObjectType.KRTZ:
            (clearedForm as KrEndangeredAreaFormTypes).endangeredAreaRasters = (clearedForm as KrEndangeredAreaFormTypes).endangeredAreaRasters?.map(item => {
                if (item.details !== undefined && item.details.blob !== null) item.details!.blob = null;
                return item;
            })
            break;
    }

    let objToSave = krToSave(clearedForm);

    formData.append('KrForm', JSON.stringify(objToSave));
    formData.append('State', props.state ? props.state : "");
    if (props.validationStatus) {
        formData.append('validationStatus', props.validationStatus);
    }

    const cardType = getCardType(props.objectType);
    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/save-${cardType}Card`, formData)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const saveCollectiveCard = async (apiUrl: string, objectType: string, forms: any, progressGid: string) => {
    let objToSave = forms.map((f: any) => {
        return krToSave(f);
    });
    const cardType = getCardType(objectType);
    return new Promise((resolve, reject) => {
        httpPost(`${apiUrl}/save-collective-${cardType}Card`, { KrForms: objToSave, ProgressGid: progressGid })
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const validateSelectedCards = async (props: ValidateSelectedCardsProps, definitions: string[][], dictBaseUrl: string) => {
    return new Promise((resolve, reject) => {
        if (props.isVerifier) {
            getCardsByWaitingRoomGidsByVerifier(props)
                .then((response: any) => {
                    getDicAndValidate(response, definitions, dictBaseUrl)
                        .then((isValid: any) => { resolve(isValid); })
                        .catch((error: any) => { reject(error); });
                })
                .catch((error: any) => { reject(error); });
        }
        else {
            getCardsByWaitingRoomGidsForFormEdit(props)
                .then((response: any) => {
                    getDicAndValidate(response, definitions, dictBaseUrl)
                        .then((isValid: any) => { resolve(isValid); })
                        .catch((error: any) => { reject(error); });
                })
                .catch((error: any) => { reject(error); });
        }
    });
}

const getDicAndValidate = async (cards: any, definitions: string[][], dictBaseUrl: string) => {
    let DictionariesLandslide: Dictionary = {};
    let gids: string[] = getMscGids(cards);
    let miejscowosciGminyWhere = gids.length > 0 ? `GLOBALID IN(${gids.map(g => `'${g}'`).join(",")})` : undefined;
    return new Promise((resolve, reject) => {
        getDictionariesForValidation(dictBaseUrl, definitions, DictionariesLandslide, miejscowosciGminyWhere)
            .then(() => {
                var valid = true;
                valid = checkValidation(cards.landslides, ObjectType.KRO, DictionariesLandslide);
                if (valid) {
                    valid = checkValidation(cards.endangeredArea, ObjectType.KRTZ, DictionariesLandslide);
                };
                resolve(valid);
            }).catch((err) => { reject(err); });
    });
}

export const saveRegistrationCardComments = async (props: SaveRegistrationCardCommentsProps) => {
    const formData = new FormData();
    formData.append('KrFormComments', JSON.stringify(props.comments));
    formData.append('WaitingRoomId', props.waitingRoomId!.toString());

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/save-registration-card-comments`, formData)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

const checkValidation = (krForms: any[], objectType: ObjectType, dictionariesForValidation?: Dictionary) => {
    var valid = true;
    var config: ConfigField = {};
    for (const krForm of krForms) {
        if (!valid) break;
        const patternType = objectType === ObjectType.KRO ? krForm.landslideAttributes.wersja : krForm.endangeredAreaAttributes.wersjA_KARTY;

        config.Validation = createValidationKrForm(krForm, objectType, patternType, dictionariesForValidation);
        krForm.config = config;
        var form = validationErrorsKrForm(krForm, objectType, patternType, false, dictionariesForValidation);
        valid = form.config?.isValid === true;
    }
    return valid;
}

export const getCardsByWaitingRoomGidsByVerifier = async (props: ValidateSelectedCardsProps) => {
    const formData = new FormData();
    formData.append('WaitingRoomGids', JSON.stringify(props.waitingRoomGids));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/get-cards-verifier`, formData)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const getCardsByWaitingRoomGidsForFormEdit = async (props: ValidateSelectedCardsProps) => {
    const formData = new FormData();
    formData.append('WaitingRoomGids', JSON.stringify(props.waitingRoomGids));

    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/get-cards-edit`, formData)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

const getCardType = (objectType: string) => {
    return objectType === ObjectType.KRO ? 'landslide' : 'endangeredArea';
}

export const getCardsForValidation = async (props: CardsValidationProps) => {
    var waitingRoomIds: CardsVaildationRequest[] = [];
    props.waitingRoomIds.forEach((id: any) => {
        waitingRoomIds.push({
            waitingRoomId: id.toString()
        })
    })
    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/validate-registrationCards`, waitingRoomIds)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const getCardsForDownloading = async (props: CardsDownloadProps) => {
    var endpoint = "";
    const editEndpoint = "download-registrationCards-edit";
    const verificationEndpoint = "download-registrationCards-verification";
    var isBoth = false;
    switch (props.downloadMode) {
        case CardDownloadMode.Edit:
            endpoint = editEndpoint;
            break;
        case CardDownloadMode.Verification:
            endpoint = verificationEndpoint;
            break;
        case CardDownloadMode.EditAndVerification:
            isBoth = true;
            break;
    }
    if (isBoth) {
        return Promise.all([editEndpoint, verificationEndpoint].map(url => {
            var waitingRoomIds: CardsVaildationRequest[] = [];
            getWaitingRoomIdsForDownload(url === editEndpoint, waitingRoomIds, props.waitingRoomRecs);
            return new Promise((resolve, reject) => {
                httpPost(`${props.apiBase}/${url}`, waitingRoomIds)
                    .then((res: any) => {
                        resolve(res.data);
                    })
                    .catch((error: any) => {
                        reject(error);
                    })
            })
        }))
    }
    else {
        var waitingRoomIds: CardsVaildationRequest[] = [];
        props.waitingRoomRecs.forEach((rec: any) => {
            waitingRoomIds.push({
                waitingRoomId: rec.ID.toString()
            })
        })
        return new Promise((resolve, reject) => {
            httpPost(`${props.apiBase}/${endpoint}`, waitingRoomIds)
                .then((res: any) => {
                    resolve(res.data);
                })
                .catch((error: any) => {
                    reject(error);
                })
        })
    }
}

const getWaitingRoomIdsForDownload = (isEdit: boolean, waitingRoomIds: CardsVaildationRequest[], waitingRoomRecs: any[]) => {
    const editStates: ObjectState[] = [ObjectState.Assigned, ObjectState.ToBeCorrected, ObjectState.WaitingRoomEdition];
    const verificationStates: ObjectState[] = [ObjectState.ToBeVerified, ObjectState.WaitingRoomEditionVerification];
    var filteredRecs = waitingRoomRecs.filter(rec => isEdit ? editStates.includes(rec.STAN_OBIEKTU_DOM) : verificationStates.includes(rec.STAN_OBIEKTU_DOM));
    filteredRecs.forEach((rec: any) => {
        waitingRoomIds.push({
            waitingRoomId: rec.ID.toString()
        })
    })
}

export const changeValidationStatus = async (props: StatusValidationCardProps) => {
    return new Promise((resolve, reject) => {
        httpPost(`${props.apiBase}/update-validation-status`, props.waitingRoomAttr)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const checkEditorCards = async (props: CheckEditor, apiBase: string) => {
    return new Promise((resolve, reject) => {
        httpPost(`${apiBase}/check-editor-cards`, props)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    })
}

export const getPdfCard = async (apiBase: string, waitingRoomId: string) => {
    return new Promise((resolve, reject) => {
        httpPostDownloadFile(`${apiBase}/get-preview-card`, { waitingRoomId: waitingRoomId })
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                console.log("ERROR", error.response.data.text());
                reject(error.response.data);
            })
    })
}

export const getMiejscowosciGids = (cardResponse: Cards) => {
    return _getMscGids(cardResponse.populateLandslideCardResponse, cardResponse.populateEndangeredAreaCardResponse);
}

export const getMscGids = (krForms?: any) => {
    return _getMscGids(krForms.landslides, krForms.endangeredArea);
}

export const _getMscGids = (landslides?: any, endangeredArea?: any) => {
    let gids: string[] = [];

    function tryToAdd(mGid?: string | null) {
        if (Boolean(mGid) && gids.includes(mGid as string) === false) {
            gids.push(mGid as string);
        }
    }

    if (endangeredArea) {
        endangeredArea.forEach((p: KrEndangeredAreaFormTypes) => {
            tryToAdd(p.endangeredAreaAttributes?.miejscowosC_GID);
        });
    }
    if (landslides) {
        landslides.forEach((p: KrLandslideFormTypes) => {
            tryToAdd(p.landslideAttributes?.miejscowosC_GID);
        });
    }
    return gids;
}

export const krToSave = (clearedForm: krFormTypes) => {
    return Object.assign({}, clearedForm, {
        dicts: undefined,
        config: undefined,
        dictionaries: undefined,
        dictionariesCodedValues: undefined,
        Validation: undefined,
        endangeredAreaGminy: undefined,
        landslideGminy: undefined
    });
}
